module.exports = __webpack_public_path__ + "static/media/Enrolled.7055ca6c.svg";